import {
    App as SP_AirDuct,
    AppExhaust as SP_AirDuctExhaust,
    AppFresh as SP_AirDuctFresh,
    AppSupply as SP_AirDuctSupply,
    AppOutgoing as SP_AirDuctOutgoing
} from './SP_AirDuct/appDeclaration';
import {
    App as SP_Filter,
    AppExhaust as SP_FilterExhaust,
    AppFresh as SP_FilterFresh,
    AppOutgoing as SP_FilterOutgoing,
    AppSupply as SP_FilterSupply
} from './SP_Filter/appDeclaration';
import { App as SP_HeatRecovery } from './SP_HeatRecovery/appDeclaration';
import {
    App as SP_HeatingCoil,
    AppPre as SP_HeatingCoilPre,
    AppRe as SP_HeatingCoilRe
} from './SP_HeatingCoil/appDeclaration';
import { App as SP_CoolingCoil } from './SP_CoolingCoil/appDeclaration';
import { App as SP_HeatingCoolingCoil } from './SP_HeatingCoolingCoil/appDeclaration';
import { App as SP_Humidifier } from './SP_Humidifier/appDeclaration';
import {
    App as SP_Fan,
    AppExhaust as SP_FanExhaust,
    AppSupply as SP_FanSupply
} from './SP_Fan/appDeclaration';
import {
    App as SP_Flap,
    AppFresh as SP_FlapFresh,
    AppSupply as SP_FlapSupply,
    AppExhaust as SP_FlapExhaust,
    AppOutgoing as SP_FlapOutgoing,
    AppRecirculation as SP_FlapRecirculating
} from './SP_Flap/appDeclaration';
import { App as SP_CoolingGenerator } from './SP_CoolingGenerator/appDeclaration';
import { App as SP_HeatingGenerator } from './SP_HeatingGenerator/appDeclaration';
import {
    App as SP_Pipe,
    AppFlow as SP_PipeFlow,
    AppOutlet as SP_PipeOutlet,
    AppPrimaryFlow as SP_PipePrimaryFlow,
    AppPrimaryOutlet as SP_PipePrimaryOutlet,
    AppSecondaryFlow as SP_PipeSecondaryFlow,
    AppSecondaryOutlet as SP_PipeSecondaryOutlet
} from './SP_Pipe/appDeclaration';
import { App as SP_Puffer } from './SP_Puffer/appDeclaration';
import { App as SP_Cabinet } from './SP_Cabinet/appDeclaration';
import { App as SP_Room } from './SP_Room/appDeclaration';
import { App as SP_OutsideConditions } from './SP_OutsideConditions/appDeclaration'

export const Apps = {
    [SP_Room.schema]: SP_Room,
    [SP_AirDuct.schema]: SP_AirDuct,
    [SP_AirDuctFresh.schema]: SP_AirDuctFresh,
    [SP_AirDuctSupply.schema]: SP_AirDuctSupply,
    [SP_AirDuctExhaust.schema]: SP_AirDuctExhaust,
    [SP_AirDuctOutgoing.schema]: SP_AirDuctOutgoing,
    [SP_Filter.schema]: SP_Filter,
    [SP_FilterFresh.schema]: SP_FilterFresh,
    [SP_FilterOutgoing.schema]: SP_FilterOutgoing,
    [SP_FilterExhaust.schema]: SP_FilterExhaust,
    [SP_FilterSupply.schema]: SP_FilterSupply,
    [SP_HeatRecovery.schema]: SP_HeatRecovery,
    [SP_HeatingCoilPre.schema]: SP_HeatingCoilPre,
    [SP_HeatingCoilRe.schema]: SP_HeatingCoilRe,
    [SP_HeatingCoil.schema]: SP_HeatingCoil,
    [SP_CoolingCoil.schema]: SP_CoolingCoil,
    [SP_HeatingCoolingCoil.schema]: SP_HeatingCoolingCoil,
    [SP_Humidifier.schema]: SP_Humidifier,
    [SP_Fan.schema]: SP_Fan,
    [SP_FanSupply.schema]: SP_FanSupply,
    [SP_FanExhaust.schema]: SP_FanExhaust,
    [SP_Flap.schema]: SP_Flap,
    [SP_FlapFresh.schema]: SP_FlapFresh,
    [SP_FlapSupply.schema]: SP_FlapSupply,
    [SP_FlapExhaust.schema]: SP_FlapExhaust,
    [SP_FlapOutgoing.schema]: SP_FlapOutgoing,
    [SP_FlapRecirculating.schema]: SP_FlapRecirculating,
    [SP_CoolingGenerator.schema]: SP_CoolingGenerator,
    [SP_HeatingGenerator.schema]: SP_HeatingGenerator,
    [SP_Pipe.schema]: SP_Pipe,
    [SP_PipeFlow.schema]: SP_PipeFlow,
    [SP_PipeOutlet.schema]: SP_PipeOutlet,
    [SP_PipePrimaryFlow.schema]: SP_PipePrimaryFlow,
    [SP_PipePrimaryOutlet.schema]: SP_PipePrimaryOutlet,
    [SP_PipeSecondaryFlow.schema]: SP_PipeSecondaryFlow,
    [SP_PipeSecondaryOutlet.schema]: SP_PipeSecondaryOutlet,
    [SP_Puffer.schema]: SP_Puffer,
    [SP_Cabinet.schema]: SP_Cabinet,
    [SP_OutsideConditions.schema]: SP_OutsideConditions,
}